module.exports = __webpack_public_path__ + "img/unblock_notification_firefox_2.48b7fc71.png";